import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'lp2-live-class-pc-promo-modal',
  templateUrl: './live-class-pc-promo-modal.component.html',
  styleUrls: ['./live-class-pc-promo-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LiveClassPcPromoModalComponent {
  constructor(
    public activeModal: NgbActiveModal
  ) { }

  onClose() {
    this.activeModal.close();
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/live-class-pc-promo-modal/live-class-pc-promo-modal.component.ts